import { AfterContentChecked, AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { ServiceAppointmentState } from '../../../store/service-appointment/service-appointment.reducer';
import * as fromSelectors from '../../../store/service-appointment/service-appointment.selectors';
import { Observable } from 'rxjs';
import * as util from '../../../shared/services/util.service';
import { debounceTime, filter, take, distinctUntilChanged } from 'rxjs/operators';
import { SubscriptionList } from '../../../shared/models/asp.types';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { ICustomer, IResponse, ITransportOption, LocationType, TransportationType } from '@signal/asp-data-commons';
import { SearchCustomersState } from '../../../store/search-customers/search-customers.reducer';
import { SearchCustomersService } from 'src/app/modules/shared/services/search-customers.service';
import { MatDialog } from '@angular/material/dialog';
import { CustomerDialogComponent } from '../../shared/customer-dialog/customer-dialog.component';
import { formatPhoneNumber } from 'src/app/modules/store/search-customers/search-customers.adapter';
import { toData } from 'src/app/modules/store/app.adapter';
import { switchMap } from 'rxjs/operators';
import { selectCurrentCustomer, selectPendingSearchInput } from '../../../store/search-customers/search-customers.selectors';
import { StateDetails } from 'src/app/modules/shared/models/state';
import { DealerState } from 'src/app/modules/store/dealer/dealer.reducer';
import { selectCities, selectStates } from 'src/app/modules/store/dealer/dealer.selectors';
import { LoadStatesAndCities } from 'src/app/modules/store/service-appointment/service-appointment.actions';
import { SettingsState } from 'src/app/modules/store/settings/settings.reducer';
import { selectSettings ,selectAllSettings} from 'src/app/modules/store/settings/settings.selectors';
import { TranslateService } from '@ngx-translate/core';
import { emailValidator, phoneValidator } from 'src/app/modules/shared/validators/custom-email-validator';
import { CustomerType } from '../../../shared/enums/customer-types.enum';

@Component({
  selector: 'app-your-information',
  templateUrl: './your-information.component.html',
  styleUrls: ['./your-information.component.scss']
})
export class YourInformationComponent implements OnInit, AfterViewInit, OnDestroy, AfterContentChecked {
  @Input() isEditMode: boolean;
  @Input() stepIndex = 3;
  @Input() isValidTransport;
  @Input() isFirstLoad = true;
  @Output() formEdited:EventEmitter<boolean>=new EventEmitter();
  @Output() transportEdited:EventEmitter<boolean>=new EventEmitter();
  @Output() firstLoadConsumed: EventEmitter<void> = new EventEmitter();
  @Input() selectedIndex: number
  isDRVAFlagSet: boolean;
  noCustomerFound = false;
  searchLoading = false;
  selectedTransportByType: any;
  step: UntypedFormGroup;
  amenities$: Observable<string[]>;
  view = 'summary';
  makeModelYear = '2020 YARIS HATCHBACK';
  signedIn: boolean;
  termsAccepted = true;
  imageUrl$: Observable<string>;
  makeModelYear$: Observable<string>;
  isRemoteLocation: boolean;
  detailMap$: Observable<{ [key: string]: string }>;
  private subs: SubscriptionList = {};
  remoteZipCode$: Observable<string>;
  isValidRemoteZip = false;
  isRemoteAddressZip: boolean = true;
  transportOptions$: Observable<ITransportOption[]>;
  remoteValidZipcodes: { pmaZipCodes: string[], isRemote: boolean };
  remoteZipcodes$: Observable<{ pmaZipCodes: string[], isRemote: boolean }>;
  lastRemoteZipCode: string;
  states$: Observable<StateDetails[]>;
  cities$: Observable<{ [key: string]: string[] }>;
  stateName: string;
  otherStateName: string;
  isCustomerAddressMandate: boolean;
  department:string;
  preferredCountries: string = this.translateService.currentLang ? this.translateService.currentLang.split('-')[1].toLowerCase(): 'us';
  formStates = {
    "customerAddress": { states: [] },
    "pickUpAddress": { states: [] },
    "dropOffAddress": { states: [] }
  }
  formcities = {
    "customerAddress": { cities: { statecities: {} } },
    "pickUpAddress": { cities: { statecities: {} } },
    "dropOffAddress": { cities: { statecities: {} } }
  }
  isHomeLocationSame: boolean = true;
  isPickUpLocationSame: boolean = true;
  isEditApptContentNotSet = true;
  transportSelected: string;
  locationType: LocationType;
  matcher = new util.DirtyErrorStateMatcher();
  transportsForSelectedType: any[] = [{ desc: 'test' }];
  private apptTransportByType: { [p: string]: any[] };
  constructor(
    private readonly formBuilder: UntypedFormBuilder,
    private readonly searchCustomersState: Store<SearchCustomersState>,
    private readonly serviceAppointmentState: Store<ServiceAppointmentState>,
    private readonly dealerState: Store<DealerState>,
    private settingsState: Store<SettingsState>,
    private readonly translateService: TranslateService,
    private readonly searchCustomersService: SearchCustomersService,
    public dialog: MatDialog
  ) {
    this.isDRVAFlagSet = false;
    this.subs.settings = this.settingsState.select(selectSettings).subscribe(settings => {
      this.isCustomerAddressMandate = settings?.portal?.mandateCustomerAddress;
      this.isRemoteAddressZip = this.isCustomerAddressMandate;
    });
 
  }

  get f() {
    return this.step.controls;
  }

  get value() {
   
    return this.step.value;
  }

  ngOnInit(): void {
    this.ready();
    const control = this.step.get('appointmentComments');
    control.markAsTouched();
    control.updateValueAndValidity();
  }

  login() {
  }



  ready() {
    this.subs.detailMapSub = this.serviceAppointmentState.select(fromSelectors.selectAppointmentFormAndLookUpData)
      .pipe(debounceTime(300))
      .subscribe(d => this.detailMap$ = this.serviceAppointmentState.select(fromSelectors.selectAppointmentFormDetailMap));

    this.step = this.formBuilder.group({
      transport: [''],
      remoteZipCode: [''],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      phoneNumber: ['', [Validators.required, phoneValidator]],
      email: ['', [emailValidator]],
      customerType: [''],
      businessName: [''],
      isRemoteLocation: [false],
      customerAddress: this.formBuilder.group({
        addressLine1: [''],
        addressLine2: [''],
        city: [''],
        state: [''],
        zip: [''],
        stateAbbr: [''],
        isZipValid: [false]
      }),
      pickUpAddress: this.formBuilder.group({
        addressLine1: [''],
        addressLine2: [''],
        city: [''],
        state: [''],
        zip: [''],
        stateAbbr: [''],
        isZipValid: [false]
      }),
      dropOffAddress: this.formBuilder.group({
        addressLine1: [''],
        addressLine2: [''],
        city: [''],
        state: [''],
        zip: [''],
        stateAbbr: [''],
        isZipValid: [false]
      }),
      otherAddress: [false],
      appointmentComments: ['',[Validators.pattern(/^[^*~`^_]*$/)]]
    });
    this.imageUrl$ = this.serviceAppointmentState.select(fromSelectors.selectVehicleFormImageUrl);
    this.makeModelYear$ = this.serviceAppointmentState.select(fromSelectors.selectVehicleFormMakeModelYearText);

    this.transportOptions$ = this.serviceAppointmentState.select(fromSelectors.selectTransportOptions);
    this.remoteZipcodes$ = this.serviceAppointmentState.select(fromSelectors.selectPMAZipCodesAndRemoteIndicator);

    this.subs.zipcodesAndRemote = this.serviceAppointmentState.select(fromSelectors.selectPMAZipCodesAndRemoteIndicator).subscribe(zipcodes => { this.remoteValidZipcodes = zipcodes }
    )

    this.subs.isRemoteLocationSub = this.serviceAppointmentState.select(fromSelectors.selectAvailabilityFormIsRemoteLocation)
      .subscribe(isRemoteLocation => {
        this.isHomeLocationSame = isRemoteLocation;
        this.isRemoteLocation = isRemoteLocation;
        this.step.controls.isRemoteLocation.setValue(isRemoteLocation);
        // this.setValidators();
      });

    //  this.subs.otherAddressSub = this.step.controls.otherAddress.valueChanges.subscribe(v => this.setOtherAddressValidators());
    this.subs.remoteZipCodeSub = this.serviceAppointmentState.select(fromSelectors.selectAvailabilityFormRemoteZipCode)
      .subscribe(remoteZipCode => {
        if (!this.isEditMode) {
          this.step.controls['customerAddress'].patchValue({
            zip: remoteZipCode
          });
          this.step.controls['dropOffAddress'].patchValue({
            zip: remoteZipCode
          });
          this.step.controls['pickUpAddress'].patchValue({
            zip: remoteZipCode
          });
          this.dispatchZip(remoteZipCode);
          this.getStateCities(remoteZipCode, 'pickUpAddress');
          this.getStateCities(remoteZipCode, 'customerAddress');
          this.getStateCities(remoteZipCode, 'dropOffAddress');
        }
      });

    this.step.controls.remoteZipCode.setValidators(this.zipValidator());
    this.subs.editModeSub = this.step.controls.remoteZipCode.valueChanges.subscribe(zip => {
      if (this.lastRemoteZipCode !== zip) {
        this.lastRemoteZipCode = zip;
        this.checkZipCodes(zip);
      }
    });


    this.states$ = this.dealerState.select(selectStates);
    this.cities$ = this.dealerState.select(selectCities);
    this.subs.allSettings = this.settingsState.select(selectAllSettings) .subscribe(item => {
      this.department=item.department
    });

    this.step.controls?.customerType?.valueChanges.pipe(
      debounceTime(100),
      distinctUntilChanged()).subscribe((type) => {
      this.setCustomerData(type)
    });
  }

  setCustomerData(type: boolean | string): void {
    const businessNameControl = this.step.controls.businessName;
    const customerTypeControl = this.step.controls.customerType;
    const firstNameControl = this.step.controls.firstName;
    const lastNameControl = this.step.controls.lastName;
    const isBusiness = type === true || type === CustomerType.BUSINESS;
    const currentType = customerTypeControl.value;
    const newType = isBusiness ? CustomerType.BUSINESS : CustomerType.INDIVIDUAL;
    if (currentType !== newType) {
      customerTypeControl.patchValue(newType);
    }
    if (isBusiness) {
      firstNameControl.clearValidators();
      firstNameControl.setErrors(null);
      lastNameControl.clearValidators();
      lastNameControl.setErrors(null);
      businessNameControl.setValidators([Validators.required]);
    } else {
      firstNameControl.setValidators(Validators.required);
      lastNameControl.setValidators(Validators.required);
      businessNameControl.clearValidators();
      businessNameControl.patchValue('');
    }

    firstNameControl.updateValueAndValidity();
    lastNameControl.updateValueAndValidity();
    customerTypeControl.updateValueAndValidity();
    businessNameControl.updateValueAndValidity();
  }

  isControlRequired(controlName: string): boolean {
    const control = this.step.get(controlName);
    if (!control?.validator) {
      return false;
    }
    const validator = control.validator({} as any);
    return validator && validator['required'];
  }

  onCustomerTypeChange(isChecked): void {
    this.setCustomerData(isChecked);
  }

  disableSearchBtn(): boolean | null {
    if (this.searchLoading) { return true; }
    const email = this.step.get('email').value;
    const phoneNo = this.step.get('phoneNumber').value;
    return (email || phoneNo) ? null : true;
  }

  searchCustomer(): void {
    this.noCustomerFound = false;
    const email = this.step.get('email');
    const phone = this.step.get('phoneNumber');
    const query = (email.valid && email.value) ? email.value
      : (phone.valid && phone.value) ? phone.value : '';
    if (!query) { return; }
    this.searchLoading = true;
    this.searchCustomersService.getCustomers('', '', query).pipe(
      switchMap((response: IResponse<ICustomer[]>) => toData(response))
    ).subscribe(
      results => {
        this.handleResults(results);
        this.searchLoading = false;
      },
      () => { this.searchLoading = false; }
    );
  }

  private handleResults(results: ICustomer[]): void {
    if (results.length === 1) {
      this.handleSingleResult(results);
    } else if (results.length > 1) {
      this.handleMultipleResults(results);
    } else {
      this.noCustomerFound = true;
    }
  }

  private handleSingleResult(results: ICustomer[]): void {
    this.applyCustomerResult(results[0]);
  }

  private handleMultipleResults(results: ICustomer[]): void {
    const dialogRef = this.dialog.open(CustomerDialogComponent, {
      width: '600px',
      height: '400px',
      data: results
    });
    dialogRef.afterClosed().subscribe(selected => {
      if (selected) { this.applyCustomerResult(selected); }
    });
  }

  private applyCustomerResult(customer: ICustomer): void {
    this.isDRVAFlagSet = customer.drvaFlag || false;
    if (!this.isDRVAFlagSet) {
      const formatted = formatPhoneNumber([customer])[0];
      this.step.patchValue({
        firstName: customer.firstName || '',
        lastName: customer.lastName || '',
        email: customer.emailAddress || '',
        phoneNumber: formatted.phoneNumber || ''
      });
    }
  }

  ngOnDestroy(): void {
    util.unsubscribeSubscriptions(this.subs);
  }

  ngAfterViewInit(): void {
    this.subs.customerSub =
      this.serviceAppointmentState.select(fromSelectors.selectIsEditMode)
        .subscribe(isEditMode => {
          if (!isEditMode) {
            this.subs.currentCustomer = this.searchCustomersState.select(selectCurrentCustomer)
              .subscribe(customer => {
                if(customer){
                  this.applyCustomerResult(customer);
                  this.step.controls.customerType.setValue(customer?.customerType || CustomerType.INDIVIDUAL);
                  this.step.controls.businessName.setValue(customer?.businessName);
                  if (customer.address) {
                    const control = 'customerAddress';
                    this.patchAddressFields('customerAddress', { ...customer.address, isZipValid: false });
                    if (customer.address.zip && customer.address.zip.length === 5) {
                      if (customer.address.state && !customer.address.state.length) {
                        this.zipChange(customer.address.zip, control)
                      } else { 
                        const state = customer.address.state
                        const city = customer.address.city ? customer.address.city : "";
                        this.formStates[control].states = [state];
                        this.formcities[control].cities.statecities = [{ state, cities: [city] }];
                      }
                    }
                  }
                }
                else if (this.isFirstLoad) {
                  this.patchPendingSearchInput();
                }
              });
          } else {
            this.searchCustomersState.select(selectCurrentCustomer)
              .subscribe(customer => {
                if(customer){
                  this.isDRVAFlagSet = customer.drvaFlag || false;
                  if (this.isDRVAFlagSet) {
                    this.step.controls.email.setValue('');
                    this.step.controls.phoneNumber.setValue(' '); // null, undefined and '' are not clearing the phone number field
                  } else {
                    const { emailAddress = '', phoneNumber = '' } = customer;
                    this.step.controls.email.setValue(emailAddress);
                    this.step.controls.phoneNumber.setValue(phoneNumber);
                  }
                } else {
                  this.step.controls.phoneNumber.setValue(this.step?.value?.phoneNumber || '');
                }
              });
          }
        });
        this.subs.valueChanges = this.step.valueChanges.subscribe(()=>{
          this.formEdited.emit(!this.step.dirty);
        });

        this.subs.transportChange = this.step.controls.transport.valueChanges.subscribe((value)=>{
          this.transportEdited.emit(value);
        });

  }

  onChangeOfAcceptTerms($event: MatCheckboxChange) {
    // this.termsAccepted = $event.checked;
    this.termsAccepted = true;
  }

  get getDisclaimerText() {
    return this.translateService.instant('testDrive.privacyPolicyTxt');
  }

  zipValidator(): ValidatorFn {
    
    return (control: UntypedFormControl): ValidationErrors => {
      if ((this.step.value.transport === 'REMOTE' || this.step.value.transport === 'PICKUP' || this.step.value.transport === 'DELIVERY') && !this.isValidRemoteZip) {
        this.step.controls['customerAddress'].patchValue({
          isZipValid: false
        });
        this.step.controls['dropOffAddress'].patchValue({
          isZipValid: false
        });
        this.step.controls['pickUpAddress'].patchValue({
          isZipValid: false
        });
        return { remoteZipCode: 'Invalid remoteZipcode' };
      } else {
        if (this.isValidRemoteZip) {
          this.step.controls['customerAddress'].patchValue({
            isZipValid: true
          });
          this.step.controls['dropOffAddress'].patchValue({
            isZipValid: true
          });
          this.step.controls['pickUpAddress'].patchValue({
            isZipValid: true
          });
        }
        return null;
      }
    };
  }

  checkZipCodes(value) {
    this.step.controls.remoteZipCode.clearValidators();

    if (this.step.value.transport === 'REMOTE' || this.step.value.transport === 'PICKUP' || this.step.value.transport === 'DELIVERY' ) {
      this.subs.remoteZip = this.remoteZipcodes$
        .pipe(filter(zip => !!zip?.pmaZipCodes?.length),
          take(1))
        .subscribe(zip => {
          this.isValidRemoteZip = zip.pmaZipCodes.findIndex(x => x === value) !== -1;
          this.step.controls.remoteZipCode.setValidators(this.zipValidator());
          this.step.controls.remoteZipCode.updateValueAndValidity();
        });
    }
  }
  private mapZipCodeResponse(response, control) {
    if (response.stateCity && response.stateCity.length > 0 && this.step.value[control].zip === response.postalCode) {
      if (response.stateCity.length === 1) {
        this.step.controls[control].patchValue({ state: response.stateCity[0].state })
        this.formStates[control].states = [response.stateCity[0].state];
        this.formcities[control].cities.statecities = response.stateCity;
        if (response.stateCity[0].cities.length === 1) {
          this.step.controls[control].patchValue({ city: response.stateCity[0].cities[0] })
        } else {
          if (!this.isEditMode) {
            this.step.controls[control].patchValue({ city: '' })
          }
        }
      }
      else {
        const states = [];
        let cities = {}
        for (const statecities of response.stateCity) {
          states.push(statecities.state);
          cities = { ...cities, statecities: response.stateCity }
        }
        this.formStates[control].states = states;
        this.formcities[control].cities = cities;
      }
    }
    else {
      if (this.step.value[control].zip === response.postalCode) {
        this.step.controls[control].get('zip').setErrors({ required: this.translateService.instant('service.invalidZip') });
        this.step.controls[control].get('zip').setValidators(Validators.required);
      }
    }
  }
  getStateCities(value, control) {
    const props = { zipCode: value };
    this.subs.statesAndCities = this.serviceAppointmentState.select(fromSelectors.selectStatesAndCitiesBasedOnZip, props).subscribe(response => {
      if (response) {
        this.mapZipCodeResponse(response, control);
      }
    })
  }
  zipChange(value, control: string) {
    if (value && value.length === 5) {
      this.dispatchZip(value);
     
      this.getStateCities(value, control)
    }
  }
  dispatchZip(value) {
    if (value && value.length >= 5) {
      this.serviceAppointmentState.dispatch(new LoadStatesAndCities({ zipPinCode: value }))
    }
  }

  updateAddressFields(form, control) {
    switch (control) {
      case 'dropOffAddress':
      
        if (this.isPickUpLocationSame) {
          this.patchAddressFields('dropOffAddress', form);
        }
        break;
      case 'pickUpAddress':
        this.isRemoteAddressZip = form.isZipValid;
        if (this.isRemoteAddressZip) {
          if (this.isHomeLocationSame && this.isCustomerAddressMandate && this.isPickUpLocationSame) {
            this.patchAddressFields('dropOffAddress', form);
            this.patchAddressFields('customerAddress', form);
            break;
          }
          if (this.isHomeLocationSame && this.isCustomerAddressMandate) {
            this.patchAddressFields('customerAddress', form);
            break;
          }
          if (this.isPickUpLocationSame) {
            this.patchAddressFields('dropOffAddress', form);
            break;
          }
        }

        break;
      default:
        break;
    }
  }
  private patchAddressFields(addressControl: string, updatedValue) {
    this.step.controls[addressControl].patchValue({
      addressLine1: updatedValue.addressLine1,
      addressLine2: updatedValue.addressLine2,
      city: updatedValue.city,
      state: updatedValue.state,
      stateAbbr: updatedValue.stateAbbr,
      zip: updatedValue.zip,
      isZipValid: updatedValue.isZipValid
    });
    if (updatedValue === '') {
      this.step.controls[addressControl].patchValue({
        addressLine1: '',
        addressLine2: '',
        city: '',
        state: '',
        stateAbbr: '',
        zip: '',
        isZipValid: false
      });
    }
  }
  updateSwitchValues(val: boolean, property: string) {
  
    switch (property) {
      case 'homelocationsame':
        this.isHomeLocationSame = val;
        if (val) {
          this.patchAddressFields('customerAddress', this.step.value.pickUpAddress);
          break;
        }
        this.patchAddressFields('customerAddress', '');
        break;
      case 'pickuplocationsame': {

        this.isPickUpLocationSame = val;
        if (val && this.isHomeLocationSame) {
          this.patchAddressFields('dropOffAddress', this.step.value.pickUpAddress);
          this.patchAddressFields('customerAddress', this.step.value.pickUpAddress);
          break;
        }
        if (val) {
          this.patchAddressFields('dropOffAddress', this.step.value.pickUpAddress);
          break;
        }
        this.patchAddressFields('dropOffAddress', '');
        break;
      }
      default:
        break;
    }
  }
  ngAfterContentChecked(): void {
   
    if (this.isEditApptContentNotSet && this.isEditMode) {
      if ((this.step.value.dropOffAddress?.zip && this.step.value.pickUpAddress?.zip) || (this.step.value.customerAddress.zip)) {
        this.isPickUpLocationSame = false;
        this.isHomeLocationSame = false;
        let value = '';
        if ((this.step.value.dropOffAddress?.zip && this.step.value.pickUpAddress?.zip)) {
          value = this.step.value.dropOffAddress?.zip + "," + this.step.value.pickUpAddress?.zip;
        }
        if (this.step.value.customerAddress?.zip) {
          if (value) {
            value += "," + this.step.value.customerAddress.zip;
          }
          else {
            value = this.step.value.customerAddress.zip;
          }
        }
        this.dispatchZip(value);
        const remoteOptions=[TransportationType.DELIVERY,TransportationType.PICKUP,TransportationType.REMOTE];
        if ((this.step.value.dropOffAddress?.zip && this.step.value.pickUpAddress?.zip && remoteOptions.includes(this.step.value.transport))) {
          this.getStateCities(this.step.value.dropOffAddress?.zip, "dropOffAddress");
          this.getStateCities(this.step.value.pickUpAddress?.zip, "pickUpAddress");
        }
        if (this.isCustomerAddressMandate && this.step.value.customerAddress?.zip) {
          this.getStateCities(this.step.value.customerAddress?.zip, "customerAddress");
        }
        this.isEditApptContentNotSet = false;
      }
    }
  }

  private patchPendingSearchInput(): void {
    this.searchCustomersState.select(selectPendingSearchInput)
      .pipe(take(1))
      .subscribe(pendingSearchInput => {
        if (!pendingSearchInput) {
          return;
        }

        const pendingFirstName = pendingSearchInput.firstName;
        const pendingLastName = pendingSearchInput.lastName;
        const currentFirstName = this.step.controls.firstName.value;
        const currentLastName = this.step.controls.lastName.value;

        if (!!pendingFirstName && !currentFirstName) {
          this.step.controls.firstName.setValue(pendingFirstName);
        }

        if (!!pendingLastName && !currentLastName) {
          this.step.controls.lastName.setValue(pendingLastName);
        }

        const pendingQuery = pendingSearchInput.query;
        const currentEmail = this.step.controls.email.value;
        const currentPhoneNumber = this.step.controls.phoneNumber.value;

        if (pendingSearchInput.filterType === 'email' && !!pendingQuery && !currentEmail) {
          this.step.controls.email.setValue(pendingQuery);
        }

        if (pendingSearchInput.filterType === 'phone' && !!pendingQuery && !currentPhoneNumber) {
          this.step.controls.phoneNumber.setValue(pendingQuery);
        }
        this.firstLoadConsumed.emit();
      });
  }

  checkFormValidity(transport)
  {   
    if(transport===TransportationType.DELIVERY )
    {
      this.clearPickupForm();
    }
    else if(transport===TransportationType.PICKUP)
    {
      this.clearDropOffForm();
    }
    else if(transport!==TransportationType.REMOTE)
    {
      this.clearDropOffForm();
      this.clearPickupForm();
    }
    //clear zip code validation if the type is not any of the below
    if(transport!==TransportationType.REMOTE && transport!==TransportationType.PICKUP && transport!==TransportationType.DELIVERY)
    {
      this.step.controls.remoteZipCode.clearValidators();
      this.step.get('remoteZipCode').updateValueAndValidity();
    }
    else{
      this.checkZipCodes(this.step.controls.remoteZipCode.value);
    }
  }
  clearDropOffForm() {
    const dropOffAddress = this.step.controls.dropOffAddress as UntypedFormGroup;
    Object.keys(dropOffAddress.controls).forEach(key => {
      dropOffAddress.controls[key].clearValidators();
      dropOffAddress.controls[key].updateValueAndValidity();
    });
  }
  clearPickupForm() {
    const pickupAddress = this.step.controls.pickUpAddress as UntypedFormGroup;
    Object.keys(pickupAddress.controls).forEach(key => {
      pickupAddress.controls[key].clearValidators();
      pickupAddress.controls[key].updateValueAndValidity();
    });
  }
}
